import { render, staticRenderFns } from "./alert-paging-selector.vue?vue&type=template&id=b77015d2&scoped=true"
import script from "./alert-paging-selector.vue?vue&type=script&lang=js"
export * from "./alert-paging-selector.vue?vue&type=script&lang=js"
import style0 from "./alert-paging-selector.vue?vue&type=style&index=0&id=b77015d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77015d2",
  null
  
)

export default component.exports